export default function SlideOverlay({ isOpen, children, className = "" }) {
  return (
    <div
      className={`absolute inset-0 z-40 transition-all duration-300 ${
        isOpen ? "translate-x-0 opacity-100" : "translate-x-full opacity-0 pointer-events-none"
      } ${className}`}
    >
      {children}
    </div>
  );
}
